<header class="position__relative header_container">
  <img class="hero_header_img" src="assets/img/legal-advice.webp">
  <div class="header_text scroll-animations container-fluid">
      <div class="header_text_container position__relative">
          <h1 class="header_title animated mb-3">AVISO LEGAL</h1>
      </div>
  </div>
</header>

<app-terms></app-terms>
<app-privacy></app-privacy>
<app-cookies></app-cookies>